// Chakra imports
import {
  Flex,
  Icon,
  Text,
  useColorModeValue,
  Box,
  Divider,
  CircularProgress,
  IconButton,
  Button,
} from "@chakra-ui/react";
import { pt } from "date-fns/locale";
// Custom components
import Card from "components/card/Card";
import { DateRangePicker } from "react-date-range";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
// Assets
import { MdAlarm, MdRefresh, MdDateRange, MdSearch } from "react-icons/md";
import Historicos from "components/dataDisplay/Historicos";
import { useEffect, useState } from "react";
import {
  buscarHistoricoPedidos,
  buscarHistoricoUltimosSetePedidos,
} from "config/apis/requests";
import PopOverAlertOrange from "components/popAlert/popAlert";
import { IsEmpty } from "config/functions";

export default function Balance(props: {
  dataUser: any;
  pedidoAtualizar: any;
  motivos: any;
  codigoProduto?: any;
}) {
  const { dataUser, pedidoAtualizar, motivos, codigoProduto } = props;
  const blueIcon = useColorModeValue("blue.500", "white");
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const [historicoPedidos, setHistoricoPedidos] = useState([]);
  const [semHistorico, setSemhistorico] = useState("");
  const [periodo, setPeriodo] = useState(1);
  const [isOpenAlerta, setIsOpenAlerta] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const redIcon = useColorModeValue("red.500", "white");
  const [modalData, setModalData] = useState(false);
  const [idProduto, setIdProduto] = useState(0);
  const handleOpenAlert = (status: boolean) => {
    setIsOpenAlerta(status);
  };
  const shadow = useColorModeValue(
    "18px 17px 40px 4px rgba(112, 144, 176, 0.1)",
    "unset"
  );
  const handleRefresh = (status: boolean) => {
    setIsRefresh(true);
  };
  const handleSelect = (ranges: any) => {
    setSelectedDateRange(ranges.selection);
  };
  const [selectedDateRange, setSelectedDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });
  const onChangeModalDataClose = () => {
    if (document.getElementById("fotoElementoUsuario"))
      if (document.getElementById("fotoElementoUsuario"))
        document.getElementById("fotoElementoUsuario").style.display = "block";
    if (document.getElementById("fotoElementoUsuario2"))
      if (document.getElementById("fotoElementoUsuario2"))
        document.getElementById("fotoElementoUsuario2").style.display = "block";
    setModalData(!modalData);
  };
  const onChangeModalData = () => {
    if (document.getElementById("fotoElementoUsuario"))
      if (document.getElementById("fotoElementoUsuario"))
        document.getElementById("fotoElementoUsuario").style.display = "none";
    if (document.getElementById("fotoElementoUsuario2"))
      if (document.getElementById("fotoElementoUsuario2"))
        document.getElementById("fotoElementoUsuario2").style.display = "none";
    setModalData(!modalData);
  };
  const [dateRangeApi, setDateRangeApi] = useState({
    startDate: null,
    endDate: null,
    key: "selection",
  });

  interface PedidoTransformado {
    numero: number;
    valor: number;
    data: string;
    idTipo: number;
    tipo: string;
    status: string;
    podeExcluir: boolean;
    dataPagamento: string;
    tipoPagamento: string;
    valorTaxaEntrega: number;
    nrRastreamento: any;
    valorPago: any;
    numeroItemPedido: number;
    endereco: [];
  }
  function transformarPedido(pedido: any): PedidoTransformado {
    const itemPedido = pedido.itensPedido[0];
    const pagamentoPedido = pedido.pagamentosPedido[0];
    return {
      numero: pedido.numero,
      valor: itemPedido.valor ? itemPedido.valor : pedido.valorPago,
      data: pedido.dataInclusao,
      idTipo: itemPedido.idServico,
      tipo: itemPedido.servico,
      status: pedido.statusPedido,
      podeExcluir: pedido.podeExcluir,
      dataPagamento: pedido.dataPagamento,
      tipoPagamento: pagamentoPedido?.formaPagamento,
      valorTaxaEntrega: 0,
      // todo valorPago: itemPedido.valor ? itemPedido.valor : pedido.valorPago,
      valorPago: pedido.valorPago,
      nrRastreamento: itemPedido.nrRastreamento,
      numeroItemPedido: itemPedido.numeroItem,
      endereco: pedido.endereco,
    };
  }
  function transformarPedidos(pedidos: any[]): PedidoTransformado[] {
    return pedidos.map(transformarPedido);
  }
  const logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("stayLogged");
    setIsLoading(false);
    window.location.href = "/atendimento#/auth/sign-in";
    window.location.reload();
    //}, 3000);
  };
  const onPesquisar = async (dateRange: any, idProduto: any) => {
    setHistoricoPedidos([]);
    setIsLoading(true);
    onChangeModalDataClose();
    setDateRangeApi(dateRange);

    const historico = await buscarHistoricoPedidos(
      dataUser.codigo,
      codigoProduto,
      dateRange
    );
    if (historico === 400 || historico === 404) {
      setSemhistorico("Sem dados disponíveis para pesquisa.");
      setIsLoading(false);
    }
    if (historico === 403) {
      logout();
    }
    if (historico === 500) {
      setSemhistorico("Erro ao buscar histórico.");
      setIsLoading(false);
    } else {
      const pedidosTransformado = transformarPedidos(historico);
      setIsLoading(false);
      setHistoricoPedidos(pedidosTransformado);
      setIsRefresh(false);
    }
    setModalData(!modalData);
  };

  const setarPeriodo = (periodo: any) => {
    switch (periodo) {
      case 1:
        return " 7 ";
      case 2:
        return " 15 ";
      case 3:
        return " 30 ";
      case 4:
        return " 60 ";
    }
  };

  useEffect(() => {
    if (dataUser?.numeroDocumento) {
      const fetchData = async () => {
        setIsLoading(true);
        const historico = await buscarHistoricoUltimosSetePedidos(
          dataUser.numeroDocumento,
          codigoProduto,
          periodo || 7
        );
        if (historico === 400 || historico === 404 || historico === 500) {
          setSemhistorico("Sem dados disponíveis para pesquisa.");
          setHistoricoPedidos([]);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          setHistoricoPedidos(historico);
          setIsRefresh(false);
        }
      };
      fetchData();
    }
  }, [dataUser, isRefresh, codigoProduto, periodo, pedidoAtualizar]);

  return (
    <>
      <Card
        flexDirection="column"
        {...dataUser}
        mb="20px"
        height={"container.sm"}
      >
        <PopOverAlertOrange
          handleOpenAlert={handleOpenAlert}
          isOpen={isOpenAlerta}
          title="Ops..."
          subtitle="Digite um CPF válido!"
        />
        <Flex
          direction={{ base: "column", md: "row" }} // Empilha na base, vira linha a partir de 'md'
          justify="space-between"
          align={{ base: "stretch", md: "center" }} // Alinha os itens esticados na coluna, e centralizados na linha
          gap="20px" // Adiciona um espaçamento entre os itens, que funciona em ambas as direções
          px="10px"
          pt="5px"
          mb="25px"
        >
          <Text fontSize="xl" color={textColor} fontWeight="bold">
            Pedidos
          </Text>
          <Flex
            justify="space-between"
            px={{ base: "15px", md: "10px" }} // Mais preenchimento horizontal em telas pequenas
            pt="5px"
            mb={{ base: "20px", md: "25px" }} // Margem inferior um pouco menor em telas pequenas
            align="center"
            flexWrap="wrap" // Permite que os itens quebrem para a próxima linha se não couberem
            gap="15px" // Adiciona um espaçamento para o caso de quebra de linha
          >
            <IconButton
              //isDisabled={!disableDataVt}
              aria-label="Top"
              borderRadius="50%"
              mb="5px"
              boxShadow={shadow}
              icon={
                <Icon
                  as={MdDateRange}
                  w="24px"
                  h="24px"
                  onClick={onChangeModalData}
                />
              }
            />
            <IconButton
              aria-label="Transfer"
              borderRadius="50%"
              icon={
                <Icon
                  as={MdRefresh}
                  width="30px"
                  height="30px"
                  color={"brand.500"}
                />
              }
              onClick={() => handleRefresh(true)}
            />
          </Flex>
        </Flex>

        <Flex
          direction={{ base: "column", sm: "row" }}
          justify={{ base: "flex-start", sm: "space-between" }}
          align={{ base: "stretch", sm: "center" }}
          gap={{ base: "10px", sm: "0" }}
          px="10px"
          pt="5px"
          mb="10px"
          mt="-10px"
        >
          <Text fontSize="sm" color={textColor} fontWeight="300" mb={{ base: "5px", sm: "0" }}>
            Últimos:
          </Text>
          <Flex wrap="wrap" gap="10px">
            <Button
              colorScheme={periodo === 1 ? "teal" : "brand"}
              h={"35px"}
              onClick={() => setPeriodo(1)}
              flex={{ base: "1 1 40%", sm: "auto" }}
            >
              7 dias
            </Button>
            <Button
              colorScheme={periodo === 2 ? "teal" : "brand"}
              h={"35px"}
              onClick={() => setPeriodo(2)}
              flex={{ base: "1 1 40%", sm: "auto" }}
            >
              15 dias
            </Button>
            <Button
              colorScheme={periodo === 3 ? "teal" : "brand"}
              h={"35px"}
              onClick={() => setPeriodo(3)}
              flex={{ base: "1 1 40%", sm: "auto" }}
            >
              30 dias
            </Button>
            <Button
              colorScheme={periodo === 4 ? "teal" : "brand"}
              h={"35px"}
              onClick={() => setPeriodo(4)}
              flex={{ base: "1 1 40%", sm: "auto" }}
            >
              60 dias
            </Button>
          </Flex>
        </Flex>
        <Divider mt="10px" />
        {isLoading ? (
          <Flex justify="center" px="10px" pt="5px" mb="25px">
            <CircularProgress isIndeterminate color="green.300" size="40px" />
          </Flex>
        ) : (
          <Box
            position={"static"}
            overflowX="hidden"
            overflowY={"auto"}
            maxW="100vw"
            h={!isLoading ? "100vh" : "50px"}
            whiteSpace="nowrap"
            pb="17px"
          >
            {!IsEmpty(historicoPedidos) ? (
              historicoPedidos.length > 0 &&
              historicoPedidos.map((extrato, i) => (
                // eslint-disable-next-line react/jsx-key
                <Flex
                  alignSelf={"center"}
                  justifyItems={"center"}
                  backgroundColor={
                    i % 2 === 0 ? "blackAlpha.20" : "blackAlpha.50"
                  }
                >
                  <Historicos
                    handleRefresh={handleRefresh}
                    vlTaxa={extrato?.valorTaxaEntrega || 0}
                    dtPagamento={extrato?.dataPagamento || null}
                    tpPagamento={extrato?.tipoPagamento || null}
                    idContaAcesso={
                      IsEmpty(dataUser.idContaAcesso)
                        ? 0
                        : dataUser.idContaAcesso
                    }
                    date={extrato?.data}
                    idProduto={codigoProduto || null}
                    pedido={extrato?.numero}
                    status={extrato?.statusPedido}
                    descricao={extrato?.itensPedido?.idTipo || null}
                    valor={extrato?.valorCalculadoPedido}
                    icon={
                      <Icon as={MdAlarm} color={blueIcon} w="20px" h="18px" />
                    }
                    extrato={extrato}
                  />
                </Flex>
              ))
            ) : (
              <Text
                fontSize="md"
                color={redIcon}
                fontWeight="500"
                align={"center"}
                mt={"7px"}
              >
                Sem dados disponíveis para pesquisa.
              </Text>
            )}
          </Box>
        )}
        <Divider />
      </Card>
      <Modal isOpen={modalData} onClose={onChangeModalDataClose} size={"sm"}>
        <ModalOverlay />
        <ModalContent alignSelf={"center"}>
          <ModalHeader>Escolha o período</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex justify="flex-start" h={"332px"} w={"623px"}>
              <DateRangePicker
                className="rdrDefinedRangesWrapper "
                onChange={handleSelect}
                moveRangeOnFirstSelection={false}
                months={1}
                showMonthAndYearPickers={true}
                ranges={[selectedDateRange]}
                direction="horizontal"
                locale={pt}
                displayMode="date"
                dragSelectionEnabled={true}
                showDateDisplay={true}
                headerContent={true}
                scroll={{ enabled: false }}
                showPreview={false}
                dateDisplayFormat="dd MMM, yyyy"
                editableDateInputs={false}
                staticRanges={[]}
                inputRanges={[]}
              />
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button
              leftIcon={<MdSearch />}
              colorScheme="brand"
              mr={3}
              onClick={() => onPesquisar(selectedDateRange, idProduto)}
            >
              Pesquisar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
